import { Component, Input, OnInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { LocaleSingularArg } from '@fullcalendar/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Address } from 'src/app/core/models/address.model';
import { Board } from 'src/app/core/models/board.model';
import { Location } from 'src/app/core/models/location.model';
import { SalesRep } from 'src/app/core/models/sales-rep.model';
import { UserType } from 'src/app/core/models/userType.models';
import { BoardService } from 'src/app/core/services/board.service';
import { LocationService } from 'src/app/core/services/location.service';
import { LoginService } from 'src/app/core/services/login.service';
import { SalesRepService } from 'src/app/core/services/sales-rep.service';

@Component({
  selector: 'app-location-dashboard',
  templateUrl: './locationDashboard.component.html',
  styleUrls: ['./locationDashboard.component.scss']
})

/**
 * Dashboard Component
 */
export class LocationDashboardComponent implements OnInit {
  term: any;
  readonly: boolean = false
  salesReps: SalesRep[];
  address: Address[];
  board: Board[];
  location: Location[];
  filteredLocation: Location[];
  latestLocation: Location[];
  @Input() locationFilter: (location: Location) => boolean; // Input filter for locations

  addEditMode: any;
  addEditFormGroup: FormGroup;

  constructor(private salesRepService: SalesRepService, 
    private locationService: LocationService, private boardService: BoardService,
     private modalService: NgbModal, private loginService: LoginService) {
  }

  // bread crumb items
  breadCrumbItems: Array<{}>;

  async ngOnInit(): Promise<void> {
    this.breadCrumbItems = [{ label: 'Fortune' }, { label: 'Contracts', active: true }];
    this.readonly = this.loginService.userType != UserType.EXTERNAL
    await this.refresh();
  }

  async refresh() {
    if(this.loginService.userType == UserType.EXTERNAL) {
      this.readonly = true;
    } else {
      this.salesReps = await this.salesRepService.getAll();
      this.location = await this.locationService.getAll();
      this.board = await this.boardService.getAll();
      this.readonly = false;
    }
    this.location = await this.locationService.getAll();
    this.latestLocation = await this.locationService.getLatest();
  
    console.log("refresh called", this)
    const allContracts = await this.locationService.getAll();
    this.location = allContracts.filter(item => 
  
      item.numBoards > 0
    );

    if (this.locationFilter) {
      this.filteredLocation = this.location.filter(this.locationFilter);
    } else {
      this.filteredLocation = this.location.filter(loc => loc.salesRep?.firstName === 'Warehouse');
    }

    this.updateFilteredLocations()
    

  }

  async onAddNew(modal: unknown) {
    this.addEditMode = "Add";
    this.addEditFormGroup = new FormGroup({
      locationTag: new FormControl<string>(''),
      locationName: new FormControl<string>(''), 
      boardInfo: new FormControl<string>(''),
      salesRep: new FormControl<string>(''),
      locationStartDate: new FormControl<string>(''),
      locationEndtDate: new FormControl<string>(''),
      enabled: new FormControl<boolean>(true),            
      businessAddress: new FormGroup({
        streetAddress1: new FormControl<string>(''),
        streetAddress2: new FormControl<string>(''),
        city: new FormControl<string>(''),
        state: new FormControl<string>(''),
        zipCode: new FormControl<string>(''),
        country: new FormControl<string>(''),
      }),
    });
    try {
      const results = await this.modalService.open(modal).result;
      console.log('add edit modal returned', {results, addEditFormGroup: this.addEditFormGroup.value});
      if(results=="Save click") {
        const newLocationData = this.addEditFormGroup.value
        if(newLocationData.boardInfo) {newLocationData.boardInfo = {id: newLocationData.boardInfo}}
        if(newLocationData.salesRep) {newLocationData.salesRep = {id: newLocationData.salesRep}}
        const location = await this.locationService.create(newLocationData);
        if(location != null) {
          //TODO mark sucesss
        } else {
          //TODO mark failure
        }
      } else {
        //TODO mark cancel
      }
    } catch (error) {
      //TODO mark error
    }
    await this.refresh();
  }

  async onDelete(id: string) {
    await this.locationService.delete(id);
    await this.refresh();     
   
  }

  async onEdit(modal: unknown, original: Location) {
    this.addEditMode = "Edit";
    this.addEditFormGroup = new FormGroup({
      locationTag: new FormControl<string>(original.locationTag),
      locationName: new FormControl<string>(original.locationName),
      salesRep: new FormControl<string>(original.salesRep.id),
      enabled: new FormControl<boolean|number>(original.enabled),  
      locationStartDate: new FormControl<string>(original.locationStartDate),  
      locationEndDate: new FormControl<string>(original.locationEndDate),  // Fixed property name
      businessAddress: new FormGroup({
        id: new FormControl<string>(original.businessAddress.id),
        streetAddress1: new FormControl<string>(original.businessAddress.streetAddress1),
        streetAddress2: new FormControl<string>(original.businessAddress.streetAddress2),
        city: new FormControl<string>(original.businessAddress.city),
        state: new FormControl<string>(original.businessAddress.state),
        zipCode: new FormControl<string>(original.businessAddress.zipCode),
        country: new FormControl<string>(original.businessAddress.country),
      }),
    });
    try {
      const results = await this.modalService.open(modal).result;
      console.log('add edit modal returned', {results, addEditFormGroup: this.addEditFormGroup.value});
      if(results=="Save click") {
        const editLocationData = this.addEditFormGroup.value
        if(editLocationData.boardInfo) {editLocationData.boardInfo = {id: editLocationData.boardInfo}}
        if(editLocationData.salesRep) {editLocationData.salesRep = {id: editLocationData.salesRep}}
        const location = await this.locationService.update(original.id ,editLocationData);
        if(location != null) {
          //TODO mark sucesss
        } else {
          //TODO mark failure
        }
      } else {
        //TODO mark cancel
      }
    } catch (error) {
      //TODO mark error
    }
    await this.refresh();
  }

  async onChange() {
    console.log("onChange() called", this.addEditFormGroup.value)
  }

  updateFilteredLocations(filter: any = null) {
    if(filter){
      this.filteredLocation =  this.location.filter(l =>
        (l.locationTag.toLowerCase().indexOf(filter.toLowerCase()) != -1)
        || (l.locationName?.toLowerCase().indexOf(filter.toLowerCase()) != -1) 
        || (l.salesRep?.firstName.toLowerCase().indexOf(filter.toLowerCase()) != -1)
        || (l.salesRep?.lastName.toLowerCase().indexOf(filter.toLowerCase()) != -1)
        || (l.businessAddress?.streetAddress1.toLowerCase().indexOf(filter.toLowerCase()) != -1)
        || (l.businessAddress?.city.toLowerCase().indexOf(filter.toLowerCase()) != -1)
        || (l.businessAddress?.state.toLowerCase().indexOf(filter.toLowerCase()) != -1)
        || (l.businessAddress?.zipCode.toLowerCase().indexOf(filter.toLowerCase()) != -1)
      )
    } else {
      this.filteredLocation =  this.location;
    }
  }

  onSearch() {
    const termLower = this.term.toLowerCase().trim();  // Precompute lowercase and trim for search term
    this.updateFilteredLocations(termLower);
  }

}
